import './index.scss';
import React from "react";

export const EmptyPracticeCard = () => {
    const skeltonList = new Array(4).fill(0);
    return (
        <div className='practice-channel-card-empty'>
            <div className="practice-channel-card-title skelton" />
            <div className="practice-channel-card-content">
                <div className="video-info skelton" />
                <div className={`preview-img-container`}>
                    {
                        skeltonList.map((_, index: number) => (
                            <span key={index} className="preview-img skelton" />
                        ))
                    }
                </div>
            </div>
            <div className="practice-channel-card-footer">
                <div className='practice-channel-card-footer-row my-practice-times'>
                    <span className='skelton' />
                    <span className='practice-channel-card-footer-btn skelton' />
                </div>
            </div>
        </div>
    )
}
